import type { CountryIso } from "~/types";

const koreaEligibleCountries: CountryIso[] = [
  "CAN",
  "AUT",
  "BEL",
  "BGR",
  "HRV",
  "CYP",
  "CZE",
  "DNK",
  "EST",
  "FIN",
  "FRA",
  "DEU",
  "GRC",
  "HUN",
  "IRL",
  "ITA",
  "LVA",
  "LTU",
  "LUX",
  "MLT",
  "NLD",
  "POL",
  "PRT",
  "ROU",
  "SVK",
  "SVN",
  "ESP",
  "SWE",
  "ATG",
  "ARG",
  "AUS",
  "BHS",
  "BRB",
  "BWA",
  "BRA",
  "CHL",
  "COL",
  "CRI",
  "DMA",
  "DOM",
  "ECU",
  "SLV",
  "GRD",
  "GUM",
  "GTM",
  "HTI",
  "HKG",
  "ISL",
  "ISR",
  "JAM",
  "JPN",
  "KWT",
  "MAC",
  "MAR",
  "NIC",
  "NOR",
  "PAN",
  "PER",
  "QAT",
  "KNA",
  "LCA",
  "VCT",
  "SRB",
  "SGP",
  "TWN",
  "THA",
  "TTO",
  "TUR",
  "ARE",
  "GBR",
  "USA",
  "URY",
  "VEN",
  "LIE",
  "MYS",
  "MEX",
  "NZL",
  "SUR",
  "CHE",
  "LSO",
  "RUS",
  "ALB",
  "AND",
  "BHR",
  "BIH",
  "BRN",
  "SWZ",
  "FJI",
  "GUY",
  "HND",
  "KAZ",
  "KIR",
  "MHL",
  "MUS",
  "FSM",
  "MCO",
  "MNE",
  "NRU",
  "NCL",
  "OMN",
  "PLW",
  "PRY",
  "WSM",
  "SMR",
  "SAU",
  "SYC",
  "SLB",
  "ZAF",
  "TON",
  "TUN",
  "TUV",
  "VAT"
];

export default koreaEligibleCountries;